import script from "./ApplicationLicensesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationLicensesView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationLicensesView.vue?vue&type=style&index=0&id=723f0f5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-723f0f5a"]])

export default __exports__